import { render } from "./ProductView.vue?vue&type=template&id=49a02138&scoped=true"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"

import "./ProductView.vue?vue&type=style&index=0&id=49a02138&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a02138"]])

export default __exports__